const dollars = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });

export function parseCurrency(value: string): string | null {
  const text = value.trim().replace(/^\$\s*/, '');
  if (!text) return null;
  if (!/^(?:\d+|\d{1,3}(?:,\d{3})+)(?:\.\d{0,2})?$/.test(text)) throw new Error('Enter a dollar amount such as $1,250.00 with no more than two decimal places.');
  const [whole, fraction = ''] = text.replaceAll(',', '').split('.');
  const cents = BigInt(whole) * 100n + BigInt(fraction.padEnd(2, '0'));
  if (cents > BigInt(Number.MAX_SAFE_INTEGER)) throw new Error('That dollar amount is too large.');
  return cents.toString();
}

export function formatCurrency(cents: string | number | null | undefined): string {
  return cents == null ? 'Not entered' : dollars.format(Number(cents) / 100);
}
